import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { CallController } from '@gem/call/CallController/CallController';
import { Call } from '@gem/call/CallStore/Call';
import { IcAddUserIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton, IconViewSizes } from '@gem/ui-kit';

import styles from './AddPeopleButton.styles.m.css';

interface IShareInviteLinkProps {
  call: Call;
  callController: CallController;
}

export const AddPeopleButton: FC<IShareInviteLinkProps> = observer(({ call, callController }) => {
  const { t } = useTranslation();

  return (
    <IconButton
      onClick={(): void => {
        if (callController.handlers.onAddCallMembers) {
          callController.handlers.onAddCallMembers(call);
        }
      }}
      className={styles.link}
      iconClassName={styles.icon}
      Icon={IcAddUserIcon}
      theme="11"
      text={t('common_invite_participants')}
      size={IconViewSizes.Large}
      iconSize={IconViewSizes.Auto}
    />
  );
});
